export const PATTERNS = {
    VALID_EMAIL:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

    ONLY_NUMERIC: /^[0-9]*$/,
    HUN_TAX_NUMBER: /^[0-9]{8}-[0-9]-[0-9]{2}$/,
    REGISTRATION_NUMBER: /[0-9]{2}(-)[0-9]{2}(-)[0-9]{6}/,
    PHONE_NUMBER: /^((?:\+?3|0)6)(\d{8,9})$/,
};

export const CURRENCY = {
    HUF: 'Ft',
};

export const B2B_URL = process.env.REACT_APP_SHOPIFY_STORE_URL;

export const LEGAL_SITE_URLS = {
    TERMS_AND_CONDITIONS: '/pages/altalanos-szerzodesi-feltetelek',
    PRIVACY_STATEMENT: '/pages/adatvedelmi-nyilatkozat',
};

export const B2B_ORDER_URL =
    'https://shopify.com/' +
    process.env.REACT_APP_SHOPIFY_ACCOUNT_NUMBER +
    '/account/orders/';
